import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import SearchBar from '../../Core/SearchBar';
import pin from '../../../images/map-pin_red.svg';
import arrow from '../../../images/chevron-right_black.svg';
import locationIcon from '../../../images/my-location-icon_red.svg';

export const MapContainer = styled.div`
  height: 377px;
  margin: 0 -15px;

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    margin: 0 -30px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    height: 688px;
    margin: 0;
  }
`;

export const Wrapper = styled.div`
  text-align: center;
  margin-bottom: 40px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 70px;
  }

  h2 {
    margin-bottom: 20px;
  }
`;

export const Controls = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-top: 50px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
`;

export const Search = styled(SearchBar)`
  max-width: 626px;
  margin-bottom: 10px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 0;
  }

  input[type='search'] {
    &::placeholder {
      font-size: 16px;
      font-weight: ${themeGet('fontWeights.normal')};
      font-stretch: normal;
      font-style: normal;
      line-height: 1.33;
      letter-spacing: normal;
    }
  }
`;

export const LocationButton = styled.button`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: ${themeGet('fontWeights.bold')};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  white-space: nowrap;

  &::before {
    content: '';
    height: 17px;
    width: 17px;
    background-image: url(${locationIcon});
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    margin-right: 0.35rem;
  }
`;

export const MapResults = styled.ol`
  list-style: none;
  counter-reset: my-awesome-counter;

  li {
    padding: 24px 0;
    border-bottom: 1px solid ${themeGet('colors.border-grey')};
    counter-increment: my-awesome-counter;
    position: relative;

    &::before {
      position: absolute;
      left: 0;
      width: 22px;
      height: 32px;
      display: inline-block;
      line-height: 2rem;
      color: ${themeGet('colors.white')};
      text-align: center;
      content: '';
    }
  }

  p.aria-location {
    clip: rect(0px, 0px, 0px, 0px);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  && {
    margin-top: 20px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    && {
      margin: 0;
      margin-top: 40px;
    }
  }
`;

export const ResultAccordion = styled.div``;

export const AccordionButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;

  &::before,
  &::after {
    content: '';
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  &::before {
    content: '${({ char }) => char}';
    color: ${themeGet('colors.white')};
    font-size: 14px;
    font-weight: ${themeGet('fontWeights.bold')};
    line-height: 30px;
    background-image: url(${pin});
    justify-self: flex-start;
    width: 26px;
    height: 36px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 16px;
      line-height: 26px;
    }
  }

  &::after {
    background-image: url(${arrow});
    justify-self: flex-end;
    width: 8px;
    height: 15px;
    transform: ${({ open }) => (open ? 'rotate(-90deg)' : 'rotate(90deg)')};
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    &::before {
      width: 23px;
      height: 32px;
    }

    &::after {
      width: 8px;
      height: 15px;
    }
  }
`;

export const ResultContent = styled.div`
  width: 100%;
  display: inline-flex;
  flex-direction: column;
  margin-left: 30px;
  margin-right: 20px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 0;
    margin-right: 0;
  }
`;

export const ResultCollection = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1 1 auto;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-right: 35px;
  }
`;

export const ResultDistance = styled.p`
  font-size: 18px;
  font-weight: ${themeGet('fontWeights.bold')};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.56;
  letter-spacing: normal;
  text-align: left;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-left: auto;
  }
`;

export const ResultType = styled.p`
  font-size: 18px;
  font-weight: ${themeGet('fontWeights.bold')};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.56;
  letter-spacing: normal;
  color: ${themeGet('colors.tertiary-red')};
  text-align: left;
  margin-left: 22px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex: 0 1 55%;
    margin-left: auto;
  }
`;

export const ResultLocation = styled.span`
  font-size: 16px;
  font-weight: ${themeGet('fontWeights.normal')};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex: 0 1 60%;
    margin-left: auto;
  }
`;

export const AccordionBody = styled.div`
  display: ${({ open }) => (open ? 'flex' : 'none')};

  && {
    ul {
      margin-left: auto;
    }
  }

  ul,
  ol {
    flex: 1 1 auto;
    margin-top: 10px;
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      flex: 0 1 60%;
      margin-left: auto;
    }
    li {
      display: flex;
      flex-direction: row;
      align-items: center;
      border-bottom: none;
      width: 100%;
      padding: 0;
      margin: 0 -10px;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        margin: 0;
      }

      strong,
      span {
        padding: 0 10px;
      }

      strong {
        width: 40%;

        @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
          width: 30%;
        }
      }

      span {
        width: 60%;

        @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
          width: 70%;
        }
      }
    }
  }
`;

export const ErrorText = styled.div`
  margin: 1rem 0;
  color: ${themeGet('colors.pc-red', '#E1251B')};
`;
